<div class="offer-summary bottom-fixed-panel"
        [ngClass]="{'offer-summary--with-installment': installmentStateService.firstInstallmentValue}">

    <div class="offer-summary__left">
        <div class="offer-summary__logo">
            <img alt="" [src]="logoUrl">
        </div>

        <div class="offer-summary__coverages">
            <ng-container *ngFor="let primaryBox of primaryBoxes">
                <app-offer-primary-box class="offer-primary-box"
                                       *ngIf="canShowBox(primaryBox.options, primaryBox.selectedOption, primaryBox.enabled)"
                                       [box]="primaryBox">
                </app-offer-primary-box>
            </ng-container>
        </div>
    </div>

    <div class="offer-summary__right">

        <div class="offer-summary__offer-price">
            <div class="offer-summary__offer-price__price">
                <span class="offer-summary__offer-price__price__label">{{ 'OFFER_SUMMARY_SECTION.yourPrice' | translate }}</span>
                <app-offer-price class="offer-summary__offer-price__price__amount"
                                 [hasModifications]="hasModifications"
                                 [offer]="selectedOffer"
                                 [loading]="priceLoading"
                                 [selectedPremium]="installmentStateService.premiumId"
                                 [currentModificationsPrice]="offerModificationsService.offerCurrentPrice">
                </app-offer-price>
            </div>

            <div *ngIf="showFirstInstallmentValue"
                 class="offer-summary__offer-price__installment">
                <span class="offer-summary__offer-price__installment__label">{{ 'OFFER_SUMMARY_SECTION.firstInstallment' | translate }}</span>
                <span class="offer-summary__offer-price__installment__amount">
                    <app-custom-price [price]="firstInstallmentValue"></app-custom-price>
                </span>
            </div>

            <div *ngIf="showLowestInstallmentValue"
                 class="offer-summary__offer-price__installment">
                <span class="offer-summary__offer-price__installment__label">{{ 'OFFER_SUMMARY_SECTION.installmentFrom' | translate }}</span>
                <span class="offer-summary__offer-price__installment__amount">
                    <app-custom-price [price]="lowestFirstInstallmentValue"></app-custom-price>
                </span>
            </div>

        </div>

        <div class="offer-summary__button">
            <button class="btn btn--big"
                    *ngIf="!isRecalculationMode"
                    id="next-btn"
                    [ngClass]="{
                            'btn--disabled': buttonDisabled,
                            'btn--secondary': !isRecalculationMode
                        }"
                    (click)="pay()">
                {{ buttonLabel | translate }}
            </button>

            <button class="btn btn--big"
                    *ngIf="isRecalculationMode"
                    [disabled]="recalculateButtonDisabled"
                    [ngClass]="{
                            'btn--disabled': recalculateButtonDisabled,
                            'btn--primary-inverted': isRecalculationMode
                        }"
                    (click)="recalculatePremium()">
                {{ buttonLabel | translate }}
            </button>
        </div>

    </div>

</div>
